<template>
<content-div>

    
    <div class="contArea tpd">

        <h1>기본정보 (양수인)</h1>
        <div class="tabCont">
            <div class="tglWrap faq">

                <ul>
                    <li class="tgl on">
                        <div class="tglCon">
                            <div class="tglCon">
                                <ul class="infoTable" style="padding: 10px 0;" v-if="subsc">
                                    <li>
                                        <em class="selectBoxEm">이름</em>
                                        <input type="text" style="background-color:white;" :value="user.name"  disabled>
                                    </li>
                                    <li>
                                        <em class="selectBoxEm">전화번호</em>
                                        <input type="text" style="background-color:white;" :value="user.mobile"  disabled>
                                    </li>
                                    <li>
                                        <em class="selectBoxEm">차대번호</em>
                                        <input type="text" style="background-color:white;" :value="subsc.vehicle.num_id"  disabled>
                                    </li>
                                    <li>
                                        <em class="selectBoxEm">Plus 앱 아이디</em>
                                        <input type="text" style="background-color:white;" :value="user.email"  disabled>
                                    </li>
                                    <li>
                                        <em class="selectBoxEm">멤버십</em>
                                        <input type="text" style="background-color:white;" :value="subsc.pkg.title"  disabled>
                                    </li>
                                    <li>
                                        <em class="selectBoxEm">서비스 기간</em>
                                        <textarea class="textAreaResizeNone" :value="subscPeriod" style="" disabled></textarea>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </li>
                </ul>
                
            </div>
        </div>
        
        <h1 style="margin:20px 0;">멤버십 약관 동의</h1>
        <term-service-view 
            :terms="terms"
            :adTerms="adTerms"
        ></term-service-view>

    </div>

    <div class="btnBox fullBtn" style="margin-top:50px; padding-bottom:20px;">
        <a class="btnL" @click="validate">
            양수 신청
        </a>
    </div>

    <!-- 에러 popup -->
    <popup-alert v-if="alertActivate" title="안내" @close="closeAlert">
        <popup-msg :type="popupMsg"></popup-msg>
    </popup-alert>

</content-div>
</template>

<script>
import axios from "axios";
import {api} from "@/api";
import Const from '../../helpers/Const';

import { mapState } from "vuex";
import { TermsCheckMixin } from "../../mixins/TermsCheckMixin";

import SubscApplyTermConst from "../Subsc/SubscApply/SubscApplyTermConst";

import TermServiceView from "../Term/TermServiceView";
import PopupAlert from '../../components/Popup/PopupAlert.vue';
import PopupMsg from "../../components/Popup/PopupMsgTemplate";


export default {
    name: 'Transfer',
    
    mixins: [TermsCheckMixin],
    components: {
      TermServiceView,
      PopupAlert,
      PopupMsg
    },

    beforeRouteLeave(to, from, next) {
      this.$store.commit("unsetTerms");
      next();
    },


    created () {
        this.getSubsc();
    },
    
    data() {
        return {
            onload: false,
            subsc: null,
            popupMsg: '',
            alertActivate: false,
            terms: SubscApplyTermConst.TERMS_TRANSPER.concat(SubscApplyTermConst.TERMS),
            adTerms: SubscApplyTermConst.TERMS_AD_RECEIVE,
        }
    },
    computed: {
        ...mapState({
            user: state => state.user,
            btnLoading: state => state.btnLoading,
        }),
        subscId() { return this.$route.params.subsc_id; },
        subscPeriod() {
            let period = '';
            if(this.subsc.date_start && this.subsc.date_stop)
                period = `${this.getDateFormat(this.subsc.date_start)}~\n${this.getDateFormat(this.subsc.date_stop)}`
            return period;
        },

        requestTerms(){
            let terms = {};
            this.terms.concat(this.adTerms).forEach(v => {
                terms[v.key] = v.checked; 
            });
            return terms;
        },
    },

    methods: {
        closeAlert(){
            this.alertActivate = false;
        },

        getSubsc() {
            this.$store.commit('setBtnLoading', true);
            axios.get(`${api.subscs}/showEscalation/${this.subscId}`)
            .then(({data}) => {
                this.subsc = data.data;
                this.terms = this.terms.concat(SubscApplyTermConst.TERMS_INSURANCE);

                this.terms = this.terms.filter(term=>{
                  return !(
                      (term.key === 'insurance' || term.key === 'insurance_personal_info_agree')
                      && !/power train warranty/.test(this.subsc.pkg.title.toLowerCase())
                  );
                })

                this.onload = true;
            })
            .catch((error) => {
                if(error.response.status == 401) {
                    this.$store.commit('setPopup401', true);
                } else {
                    this.$store.commit('SET_ALERT', { 
                        show: true,
                        content: this.errorMsg(error),
                        submit: () => { this.$router.go(-1); }   
                    });
                }
            });
        },

        validate() {
            if(this.btnLoading) return;

            for (let i in this.terms) {
                if (!(this.terms[i].checked || !this.terms[i].required)) {
                    this.popupMsg = 'NEED_SUBSC_TERM_CHECK'
                    this.alertActivate = true;
                    return;
                }
            }

            if(this.termAdReceiveChecked) {
                let adReceive = this.adTerms.filter((adt)=>{ return adt.checked })
                if(adReceive.length == 0){
                    this.popupMsg = 'NEED_SUBSC_TERM_RECEIVE_CHECK'
                    this.alertActivate = true;
                    return;
                }
            }
            this.set();
        },

        set() {
            this.$store.commit('setBtnLoading', true);
            axios.post(`${api.subscs}/escalation/${this.subsc.id}`, {
                terms: this.requestTerms,
            }).then( () => {

                this.$store.commit('SET_ALERT', { 
                    show: true,
                    content: '양수 신청이 완료되었습니다.',
                    submit: () => { 
                        this.terms.forEach(term => { term.checked = false; });
                        this.adTerms.forEach(term => { term.checked = false; });
                        this.$router.push({ path: `/subscStatus` , query: { vtg_id:this.user.vtg_id }}); 
                    }   
                });
            }).catch( (error) => {
                let errData = { 
					show: true,
					content: this.errorMsg(error),
				}

				if( this.getErrorStatusCode(error) ) {
					switch (this.getErrorStatusCode(error)) {
						case Const.ERROR_CODE.SUBSC_ESCALATION_GO_OAS:
							errData.btn_cancel = true;
							errData.btn_submit_title = '차량등록';
							errData.submit = () => {
								//this.oasRedirect('/bmw/user/vehicle');
								this.vtgRedirect('/bmw/user/vehicle');
							}
							break;
						case Const.ERROR_CODE.UBSC_ESCALATION_GO_SCP:
							errData.btn_cancel = true;
							errData.btn_submit_title = '가입하기';
							errData.submit = () => {
								this.$router.push({ path: `/` , query: { vtg_id: this.user.vtg_id }});
							}
							break;

					}
				}

				this.$store.commit('SET_ALERT', errData);
            })
        },
    },
}
</script>

<style lang="scss" scoped>

</style>